//import { useMediaQuery } from '@material-ui/core';
//import { FIELD_HORIZONTAL_MIN_WIDTH } from '../../constants/layout';

export default function useHorizontal() {
    return false; //useMediaQuery(`(min-width:${FIELD_HORIZONTAL_MIN_WIDTH}px)`);
}
